export default __webpack_public_path__ + "static/media/251061.73d1b4e2.jpg";